import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "./HeroSection.css";
import { LanguageContext } from "../../context/LanguageContext";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const HeroSection = () => {
  const { currentLang } = useContext(LanguageContext);
  const [hero, setHero] = useState(null);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/herosection?lang=${currentLang}`
        );
        setHero(res.data);
      } catch (error) {
        console.error("Error fetching Hero Section:", error);
      }
    };

    fetchHero();
  }, [currentLang]);

  if (!hero) return null;

  return (
    <section id="hero-section" className="hero">
      <Swiper
        modules={[Navigation, Autoplay, EffectFade]}
        navigation={true}
        effect="fade"
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        loop={true}
        className="hero-swiper"
      >
        {/* =======================================
            VIDEO SLIDE (if exists)
        ======================================== */}
        {hero.videoUrl && (
          <SwiperSlide>
            <div className="slide">
              <video
                className="background-media"
                src={resolveUrl(hero.videoUrl)}
                autoPlay
                loop
                muted
                playsInline
              />

              <div className="hero-overlay" />
              <div className="hero-content">
                <h1>{hero.title}</h1>
                <p>{hero.subtitle}</p>

                <div className="hero-buttons">
                  <Link to="/order">
                    <button className="order-now">{hero.button1}</button>
                  </Link>
                  <Link to="/testDrive">
                    <button className="test-drive">{hero.button2}</button>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        )}

        {/* =======================================
            ALL IMAGES SLIDES
        ======================================== */}
        {hero.images &&
          hero.images.length > 0 &&
          hero.images.map((imgUrl, index) => (
            <SwiperSlide key={index}>
              <div className="slide">
                <img
                  className="background-media"
                  src={resolveUrl(imgUrl)}
                  alt={`MHERO-image-${index}`}
                />

                <div className="hero-overlay" />
                <div className="hero-content">
                  <h1>{hero.title}</h1>
                  <p>{hero.subtitle}</p>

                  <div className="hero-buttons">
                    <Link to="/order">
                      <button className="order-now">{hero.button1}</button>
                    </Link>
                    <Link to="/testDrive">
                      <button className="test-drive">{hero.button2}</button>
                    </Link>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>

      <div id="hero-end" style={{ height: "1px" }}></div>
    </section>
  );
};

export default HeroSection;
